import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Icon, Row, Col } from 'antd'
import PropTypes from 'prop-types'
import typo from "../../../constants/dictionaries";
import Select from '../../Common/Select'
import Button from '../../../components/Buttons'
import { FastField } from "formik";
import ValidatedText from "../../Common/ValidatedText";
import helper from '../../../helper/helper'
import Input from '../../Common/Input'
import Api from '../../../api';
import message from "../../Messages";
import Api_tnn from '../../../api/api.tnn';



let timeout;
let currentValue;

function fetch(value, callback, user) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  if (value === "null") {
    callback([]);
  } else {
    function fake() {
      new Api_tnn().getDMSongTQ({ token: user.access_token, page: 0, size: 0, strSearch: currentValue })
        .then(res => {
          if (currentValue === value) {
            callback(res && res.data);
          }
        })
        .catch((err) => message.error(err.message))
    }
    timeout = setTimeout(fake, 1000);
  }
}
class SongVaLuuVuc extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      dataSong: [],
      dataLVSong: [],
      LVSong: []
    }
  }
  componentDidUpdate = (prevProps) => {
    const { values, mode } = this.props
    if (values.idSong) {
      if (values.idSong !== prevProps.values.idSong) {
        this.API_getDMSongTQ(values.idSong)
      }
    }
  };
  componentDidMount = () => {
    const { values, mode } = this.props
    if (values.idSong) {
      this.API_getDMSongTQ(values.idSong)
    }
    this.API_getDM_LVSong();
  }
  API_getDMSongTQ = (id) => {
    const { user } = this.props
    new Api_tnn().GetDM_SongToanQuoc({ token: user.access_token, id: id })
      .then(res => {
        let data_song = []
        if(!helper.isNullOrUndefined(res)){
          data_song.push(res)
        }
        this.setState({ dataSong: data_song })
      })
      .catch((err) => message.error(err.message))
  }

  SelectSearchSong = value => {
    const { user } = this.props;
    if (value && value !== "" && value !== undefined) {
      fetch(
        value,
        res => this.setState({ dataSong: res }),
        user
      );
    } else {
      fetch(
        "null",
        res => this.setState({ dataLVSong: res }),
        user
      );
    }
  };
  API_getDM_LVSong = () => {
    const { user } = this.props
    new Api_tnn().GetDM_LVSongs({ token: user.access_token, page: 0, size: 0, strSearch: "" })
      .then(res => {
        this.setState({ LVSong: res })
      })
      .catch((err) => message.error(err.message))
  }

  render() {
    const { dataSong, dataLVSong, LVSong } = this.state;
    const { values, setFieldValue } = this.props
    return (
      <Row>
        <Select
          placeholder={typo.cscore_thuocSong}
          width="100%"
          label={typo.cscore_thuocSong}
          name="name_song"
          name_value="id"
          value={values.idSong ? values.idSong : undefined}
          onSearch={this.SelectSearchSong}
          onSelect={(value, name) => {
            setFieldValue("idSong", value);
            setFieldValue("thuocSong", name.props.children);
          }}
          mandatory={false}
          showArrow={false}
          filterOption={false}
          defaultActiveFirstOption={false}
          notFoundContent={null}
          dataSource={dataSong.map((e, index) => ({ ...e, name_song: e.tensongsuoi + ", " + "cấp " + e.capsong + ", " + "chảy ra " + e.chayra }))}

        />
        <Select
          width="100%" placeholder={helper.genSelectPL(typo.cscore_thuocLVS)}
          label={typo.cscore_thuocLVS}
          dataSource={LVSong}
          name="tensong"
          name_value="id"
          onSelect={(value, name) => {
            setFieldValue("idLVS", value);
            setFieldValue("thuocLVS", name.props.children);
          }}
          defaultValue={values.idLVS}
          mandatory={false}
          key={values.idLVS}
          value={values.idLVS ? values.idLVS : undefined}
        />
      </Row>
    )
  };
}
SongVaLuuVuc.propTypes = {

};
const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(SongVaLuuVuc);

